import { AxiosResponse, AxiosError } from 'axios';
import {
    RequestedLoadDocumentsAction,
    SucceededLoadDocumentsAction,
    FailedLoadDocumentsAction,
    CanceledLoadDocumentsAction,
    DocumentsState,
    SetDocumentsAction,
    MergeDocumentsAction
} from './types';
import {
    DOCUMENTS_LOAD_REQUESTED,
    DOCUMENTS_LOAD_SUCCEEDED,
    DOCUMENTS_LOAD_FAILED,
    DOCUMENTS_LOAD_CANCELED,
    DOCUMENTS_SET,
    DOCUMENTS_MERGE
} from './constants';

export function loadDocuments(data: {
    documentSetId: number;
}): RequestedLoadDocumentsAction {
    return {
        type: DOCUMENTS_LOAD_REQUESTED,
        data,
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadDocuments(
    response: AxiosResponse
): SucceededLoadDocumentsAction {
    return {
        type: DOCUMENTS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadDocuments(
    error: AxiosError
): FailedLoadDocumentsAction {
    return {
        type: DOCUMENTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadDocuments(): CanceledLoadDocumentsAction {
    return {
        type: DOCUMENTS_LOAD_CANCELED
    };
}

export function setDocuments(documents: DocumentsState): SetDocumentsAction {
    return {
        type: DOCUMENTS_SET,
        payload: documents
    };
}

export function mergeDocuments(
    documents: DocumentsState
): MergeDocumentsAction {
    return {
        type: DOCUMENTS_MERGE,
        payload: documents
    };
}
